export enum PaginationType {
  CURSOR = 'cursor',
  OFFSET = 'offset',
}

export enum TableType {
  CLIENT = 'client',
  SERVER = 'server',
}
